import React, { useState } from 'react';

export const Navigation = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-2'
            onClick={handleMenuClick}
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='/'>
            <img style={{ height: 50, overflow: 'hidden', }} align="left" src="img/ronew3logo.png" alt='best ro-repair service' />
          </a>{' '}
        </div>

        <div
          className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a className="btn" href="mailto: Shaikroservice@gmail.com" ><i className="fa fa-envelope" style={{fontSize :"12px"}}> </i> Shaikroservice@gmail.com</a>
            </li>
            
            <li>

              <a className="btn" href="tel:9912300212" ><i className="fa fa-phone" style={{fontSize :"12px"}}> +91-9912300212</i></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
